// Centralized brand config for ARVI.

export const ARVI = {
  brand: "ARVI",
  tagline: "A Mother's Art. A Son's Promise.",
  // E.164 format (digits only, country code first).
  whatsapp: "918095536968",
  whatsappDisplay: "+91 80955 36968",
  instagramHandle: "@creativecrew10026",
  instagramUrl: "https://instagram.com/creativecrew10026",
};

export const waLink = (message = "") => {
  const base = `https://wa.me/${ARVI.whatsapp}`;
  if (!message) return base;
  return `${base}?text=${encodeURIComponent(message)}`;
};

// A structured default enquiry — pre-fills the WhatsApp chat so customers
// just fill in the blanks. Helps ARVI gather basic details upfront.
export const DEFAULT_WA_MESSAGE =
  `Hello ARVI 🌹\n\nI'd love to enquire about your hand-painted sarees.\n\n• Name: \n• Looking for: (saree / suit set / bridal / custom)\n• Occasion: \n• Preferred colours / motifs: \n• Budget range: \n• Timeline: \n\nPlease share design ideas and pricing. Thank you!`;
